import React, {useState} from 'react'
import { isEmpty } from 'lodash'
import { Toast } from 'antd-mobile'

const vipImg = {
  vip:require('./images/vip.png'),
  svip:require('./images/svip.png'),
  loseWeight:require('./images/weight_vip.png'),
  // TAPD 1006952/1006953：减重尊享独立成一类会员类型。
  // type 来自后端 serviceIcon.list（pigeon common/vipLabel.js 的 APP_VIP_ICON_TYPE_MAP），
  // 与 needle 的 src/modules/preferences/VipIcon.js 是同一份数据、同一套图，两边各改各的。
  // 下面取值是 `vipImg[el] || vipImg['vip']`，所以后端先上、这里没跟上也只是回落金色，不会空白。
  loseWeightExclusive:require('./images/lose_weight_exclusive_vip.png'),
}

export const VipIcon = ({vipStatus,style,userId,patientId}) => {
  const vip = vipStatus || {}
  const otherUser = userId && userId !== patientId
  // TAPD 1006953：与 needle 的 src/modules/preferences/VipIcon.js 同一口径。blog-backend 对「买了减重尊享且仍在
  // 有效期内」的看的人下发 vipEntryBlocked=true（并把 cityHasGoods 置 false），陈晓敏 2026-09-24 确认所有会员页入口都拦：
  // 别人的角标照常显示，点任何角标都只提示、不跳会员页。App 收到 VipDetailsScreen 消息会直接跳、不做判断，所以只能拦在这里。
  const entryBlocked = Boolean(vip.vipEntryBlocked)
  if (!vip.cityHasGoods && otherUser && !entryBlocked) {
    return null
  }
  if (patientId === userId && !vip.cityHasGoods && isEmpty(vip.list)) {
    return null
  }
  const postMessage = msg => {
    const data = JSON.stringify(msg)
    window.postMessage(data, '*')
  }
  // 自己的角标在 cityHasGoods=false 时也只提示（和 App 一致），被拦的看的人点别人的角标同样只提示
  const navigate = cardType => {
    if (entryBlocked || (!vip.cityHasGoods && patientId === userId)) {
      Toast.info('您的会员服务正在进行中，详情可咨询照护师', 2)
      return
    }
    postMessage({
      navigateName: 'VipDetailsScreen',
      params: { cardType }
    })
  }
  return (
    <div style={{display:'flex',alignItems:'center',marginLeft:4,...style}}>
      {isEmpty(vip.list) && (
        <div style={{display:'flex'}} onClick={() => navigate('vip')}>
          <img
            style={{width:20,height:20,marginRight:4}}
            src={require('./images/vip_not_purchased.png')}
          />
        </div>
      )}
      {!isEmpty(vip.list) && vip.list.map(el => {
        return <div onClick={() => navigate(el)}>
            <img 
              style={{width:20,height:20,marginRight:4}}
              src={vipImg[el] || vipImg['vip']}
            />
          </div>
      })}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/modules/knowledge/components/VipIcon.js